import React from 'react';
import { Save } from 'lucide-react';

const FAQForm = ({ 
  faqData, 
  setFaqData, 
  onSave 
}) => {
  const cardCls = 'bg-white rounded-xl shadow p-8 mb-10';
  const labelCls = 'block text-sm font-medium text-gray-700 mb-1';
  const inputCls = 'w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFaqData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className={cardCls}>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-700">FAQ Details</h2>
        <button
          onClick={onSave}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
        >
          <Save size={18} /> Save
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <label className={labelCls}>Question</label>
          <input
            name="question"
            value={faqData.question}
            onChange={handleChange}
            className={inputCls}
            placeholder="e.g., What is the total cost of buying a home in your project?"
          />
        </div>

        <div>
          <label className={labelCls}>Answer</label>
          <textarea
            name="answer"
            value={faqData.answer}
            onChange={handleChange}
            className={inputCls}
            placeholder="Enter the detailed answer..."
            rows={8}
          />
        </div>
      </div>
    </section>
  );
};

export default FAQForm;